module.exports = __webpack_public_path__ + "media/images/icons/loading-2f3d16895bacb0d39aa3fa347e8c17bc.svg";